import React from "react";
import type { ParameterSchema } from "@tradingdroid/frontends-types";

import { isNumericSchema } from "./types";

interface Props {
  schema: ParameterSchema | null;
}

export const RangeInfo: React.FC<Props> = ({ schema }) => {
  if (!isNumericSchema(schema)) return null;

  return (
    <span className="text-body-secondary small ms-2">
      [{schema.low} - {schema.high}, step: {schema.step}]
    </span>
  );
};
